<template>
  <b-modal
    no-close-on-backdrop
    id="assesmentmodal"
    centered
    hide-footer
    hide-header
    class="p-0"
    @hidden="closeShareModal"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span
          class="viewmark-heading"
          v-if="activeCandidate.kanbanScheduled == false"
          >Trigger Assessment</span
        >
        <span class="viewmark-heading" v-else>Retrigger Assessment</span>
      </div>
      <hr />

      <div class="jdd-xMarkCancel" @click="closeShareModal">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>

      <div class="jd-modalheight">
        <div class="jd-modal-sub-head mb-2">Configure</div>
        <div class="jd-configure-box p-3 m-1">
          <div class="d-flex align-items-center justify-content-between">
            <div style="word-break: break-all">
              Configuration Name : <b>{{ configName }}</b>
            </div>

            <div
              class="pointer"
              v-if="disableShare == false"
              @click="configView"
            >
              <img src="../../../assets/configicon.svg" alt="" />
            </div>
            <div class="pointer" v-else>
              <img src="../../../assets/configdisable.svg" alt="" />
            </div>
          </div>
          <div
            class="config-warn mt-2 p-1 config-warn-text"
            v-if="disableShare == true"
          >
            <img src="../../../assets/configwarn.svg" alt="" />

            The configuration has expired, you cannot share the assessment.
          </div>
        </div>

        <hr />
        <div class="jd-modal-sub-head mb-2">Tests</div>
        <div
          class="d-flex align-items-center mb-2 mr-2"
          v-for="(test, testindex) in selectedAssessment.selectedtests"
          :key="testindex"
        >
          <div class="testconfig-card-container w-100">
            <div
              style="width: 100%"
              class="d-flex justify-content-between align-items-center"
            >
              <div style="width: 50%">
                <div class="jd-card-sub-head">Topic Name</div>
                <div class="folder-bar-head mt-1">
                  {{ test.topicName }}
                </div>
              </div>
              <div style="width: 50%">
                <div class="jd-card-sub-head">Test Name</div>
                <div class="folder-bar-head mt-1">
                  {{ test.name }}
                </div>
              </div>
            </div>
            <hr />
            <div class="d-flex align-items-center justify-content-between mt-3">
              <div class="d-flex align-items-center flex-column">
                <div class="testconfig-card-subheads">Difficulty Level</div>
                <div
                  class="testconfig-card-subheadcontent"
                  style="color: #038e00"
                >
                  {{ test.difficultyLevel }}
                </div>
              </div>
              <div class="d-flex align-items-center flex-column">
                <div
                  class="testconfig-card-subheads"
                  v-if="test.numberOfSections <= 1"
                >
                  No.of Section
                </div>
                <div class="testconfig-card-subheads" v-else>
                  No.of Sections
                </div>
                <div
                  class="testconfig-card-subheadcontent"
                  style="color: #5782ff"
                >
                  {{ test.numberOfSections }}
                </div>
              </div>
              <div class="d-flex align-items-center flex-column">
                <div class="testconfig-card-subheads">No.of Questions</div>
                <div
                  class="testconfig-card-subheadcontent"
                  style="color: #ffc145"
                >
                  {{ test.noOfQuestions }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="mt-5 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <!-- THIS MODAL WAS OPENING BEFORE -->
              <!-- v-b-modal.recommendation -->
              <b-button
                class="jdcancelbtn"
                v-b-modal.SelOpsheadFinal
                v-if="
                  activeCandidate.kanbanLevel != 0 &&
                  activeCandidate.kanbanLevel != 1 &&
                  activeCandidate.kanbanLevel != 'H' &&
                  activeCandidate.kanbanLevel != 'F' &&
                  activeCandidate.kanbanScheduled == false
                "
                >Select candidate</b-button
              >
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="mr-3 cancelbtntext pointer" @click="closeShareModal">
              Cancel
            </div>
            <b-button
              :disabled="disableShare == true"
              class="addbtn pr-4 pl-4 pointer"
              @click="shareTest"
            >
              Share
            </b-button>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import { triggerAssessment } from "../../../utils/apiFunctions";
import toast from "../../../components/mixin/toast";

export default {
  mixins: [toast],
  name: "AssesmentModal",
  props: {
    configView: Function,
    context: Object,
    configName: String,
    activeCandidate: Object,
    selectedAssessment: Object,
  },
  data() {
    return {
      showSpinner: false,
      disableShare: false,
    };
  },
  watch: {
    "context.testConfigData.config.closeTestdt"() {
      const closeTestDateString =
        this.context.testConfigData.config.closeTestdt;

      const closeTestDate = new Date(closeTestDateString);
      const currentDate = new Date();

      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };

      const formattedCloseTestDate = closeTestDate.toLocaleString(
        "en-US",
        options
      );
      const formattedCurrentDate = currentDate.toLocaleString("en-US", options);

      if (new Date(formattedCloseTestDate) <= new Date(formattedCurrentDate)) {
        this.disableShare = true;
      } else {
        this.disableShare = false;
      }
    },
  },

  methods: {
    closeShareModal() {
      this.context.$bvModal.hide("assesmentmodal");
      this.context.selectedAssessment = {};
    },
    async shareTest() {
      this.showSpinner = true;

      try {
        let payload = {
          candidateID: [],
          panelList: [],
          jobID: "",
          customerID: "",
          level: {},
        };
        payload.candidateID.push(this.selectedAssessment.candidateID);
        if (this.selectedAssessment.kanbanLevel == 0) {
          payload.level[this.selectedAssessment.candidateID] =
            parseInt(this.selectedAssessment.kanbanLevel) + 1;
        } else {
          payload.level[this.selectedAssessment.candidateID] = parseInt(
            this.selectedAssessment.kanbanLevel
          );
        }

        payload.customerID = this.context.$route.query.customerID;
        payload.jobID = this.context.$route.query.jobID;
        let panel = "cvinfra@simplify3x.com";
        payload.panelList.push(panel);
        const res = await triggerAssessment(payload);
        if (res.status == 200) {
          if (!this.selectedAssessment.kanbanScheduled) {
            this.successModal("Assessment triggered successfully");
          } else {
            this.successModal("Assessment retriggered successfully");
          }
          if (this.context.$route.name == "JdDetails") {
            this.context.getJobDetails();
          } else {
            this.context.getCandidates();
          }
          this.context.$bvModal.hide("assesmentmodal");
        }
        this.showSpinner = false;
      } catch (error) {
        this.showSpinner = false;
        this.errorModal(error.response.data.data.status);
      }
    },
  },
};
</script>
